<template>
  <div class="search-container">
    <div class="search-header">
      <div class="container">
        <v-row>
          <v-col cols="12" lg="8">
            <div class="search-title">
              Showing <span class="search-count" v-if="categorycourses">{{categorycourses.length}}</span> results for
              <span class="search-result" v-if="$route.query.sortName">{{ this.$route.query.sortName }}</span>
              <span class="search-result" v-else>{{ this.$route.query.categoryName }}</span>
              <!-- <v-chip v-if="this.$route.query.sortName" color="error"><v-icon>mdi-close</v-icon></v-chip> -->
              <v-tooltip right v-if="this.$route.query.sortName">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    color="error"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="cancelSorting()"
                    class="ml-2"
                  >
                   <v-icon>mdi-close</v-icon>
                  </v-chip>
                </template>
                <span>Clear Sorting</span>
              </v-tooltip>
            </div>
          </v-col>
          <v-col cols="12" lg="4" class="d-flex justify-end">
            <div class="search-filter d-flex align-center">
              Sort By
              <div class="sort-filter">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn class="categories-btn" text v-on="on"
                      >Choose
                      <v-icon right dark> mdi-chevron-down </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-for="(sort, i) in sortBy" :key="i" @click="sortdata(sort.text)">
                      <v-list-item-title class="dropdown_menu">{{
                        sort.text
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>

    <section class="course-list-wrapper">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" lg="4" v-for="(course, i) in categorycourses" :key="i">
              <CourseCard
                :course="course"
              ></CourseCard>
          </v-col>
        </v-row>

        <div class="course-list__pagination" v-if="requestData.count > 6">
          <div class="text-right" v-if="categorycourses">
            <CoursePagination :page="requestData" class="justify-end"></CoursePagination>
          </div>
        </div>
      </v-container>
    </section>

    <KeepLearning></KeepLearning>
  </div>
</template>

<script>
import CourseCard from "@/components/Courses/CourseCard.vue";
import CoursePagination from "@/components/Courses/CoursePagination.vue";
import KeepLearning from "@/components/KeepLearning/KeepLearning.vue";
export default {
  data () {
    return {
      categorycourses: [],
      sortBy: [
        // { text: "Price (H - L)" },
        // { text: "Price (L - H)" },
        // { text: "Date (Newest First)" },
        // { text: "Date (Oldest First)" },
        // { text: "Not Purchased" },
        {text: "Best"},
        {text: "Feature"},
      ],
      sortText: '',
      requestData: {
        page: 1,
        page_size: 10,
        category_id: '',
        is_best: false,
        is_feature: false,
        count: '',
        length: '',
      },
    }
  },
  components: {
      CourseCard,
      CoursePagination,
      KeepLearning
  },
  created () {
       
      // this.$store.dispatch('getCategoryCourses', this.$route.query.category).then(res => {
      //     this.categorycourses = res;
      //     this.length = res.length;
      // })
  },
  mounted () {
    
    this.$bus.on('category-result', (result)=>{
        this.categorycourses = result;
    });
    this.pagination(this.$route.query.category);
  },
  destroyed () {
    this.$bus.off('category-result')
  },
  methods: {
    async pagination(id) {
      this.$bus.emit('loading-toggle');
      this.requestData.category_id = this.$route.query.category;
      await this.$api.get(`course/paginated/?page=${this.requestData.page}&page_size=${this.requestData.page_size}&category=${this.requestData.category_id}`).then(res => {
        this.requestData.count = res.count
        this.categorycourses = res.results
        if(res.count > this.requestData.page_size) {
          this.requestData.length = res.total_pages
          // console.log(result)

          // if(result <= 3) {
          // }
          // else if(result > 3 && result < 6 ) {
          //   this.requestData.length = 3;
          // }
        }
        else {
          this.requestData.length = 1;
        }
      })
      this.$bus.emit('loading-toggle');
    },
    async sortdata(val) {
      this.$bus.emit('loading-toggle')
      this.requestData.category_id = this.$route.query.category;
      this.sortText = val
      if(this.sortText === 'Best') {
        this.requestData.is_best = true
        await this.$api.get(`course/paginated/?category=${this.$route.query.category}&page=${this.requestData.page}&page_size=${this.requestData.page_size}&is_bestselling=${this.requestData.is_best}`).then(res => {
          this.categorycourses = res.results
        })
        this.$router.push(`/course/?category=${this.$route.query.category}&is_bestselling=${this.requestData.is_best}&sortName=${this.sortText}`);
        this.$bus.emit('loading-toggle')
      }
      else if(this.sortText === 'Feature') {
        this.requestData.is_feature = true
        await this.$api.get(`course/paginated/?category=${this.$route.query.category}&page=${this.requestData.page}&page_size=${this.requestData.page_size}&is_Feature=${this.requestData.is_feature}`).then(res => {
          this.categorycourses = res.results
        })
        this.$router.push(`/course/?category=${this.$route.query.category}&page_size=${this.requestData.page_size}&is_feature=${this.requestData.is_feature}&sortName=${this.sortText}`);
        this.$bus.emit('loading-toggle')
      }
    },
    async cancelSorting() {
      this.$bus.emit('loading-toggle')
      let payload = {
        category: this.$route.query.category,
      }
      await this.$api.getWithPayload('/course/paginated/',payload).then(res => {
        this.categorycourses = res.results
        this.$router.push(`/course/?category=${this.categorycourses[0].category.id}&categoryName=${this.categorycourses[0].category.name}`)
        this.$bus.emit('loading-toggle')
      })
    }
  },

  watch: {
    '$route.query.category': {
      handler(val) {
        if(this.sortText == '') {
          this.pagination(val);
        }
        
      },
      deep: true
    },
  },
}
</script>


<style>
.dashboard-header{
  background: var(--color-dark-blue);
  color: #fff;
  padding: 2rem 0;
}
.mycourses-title{
  font-size: 20px;
}
.my_courses_wrapper{
  display: grid;
  grid-template-columns: repeat(auto-fill,minmax(16em,1fr));
  grid-gap: 2rem;
}
.my_courses_card{
  border: 1px solid #ccd;
}
.my_courses_card .course_image img{
  width: 100%;
  height: auto;
}
.courses_card_body{
  padding: 1rem;
}
.courses_card_body .course_title{
  font-weight: 600;
  font-size: 1rem;
}
.course_card .course_price {
  position: relative;
}
.course_card .course_price .price {
  position: absolute;
  right: 18px;
  margin-top: -15%;
  background-color: var(--color-red);
  width: 90px;
  height: 90px;
  border-radius: 100%;
  text-align: center;
  color: var(--color-white);
  padding-top: 5px;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.5;
}
</style>
